import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Customer } from '@inyova/models';

import { ProfileTab } from 'src/app/modules/shared/models/Profile';

@Component({
  selector: 'app-profile-desktop',
  templateUrl: './profile-desktop.component.html',
  standalone: false
})
export class ProfileDesktopComponent {
  @Input() activeTabName: ProfileTab;
  @Input() customer: Partial<Customer>;
  @Input() editDisabled: boolean;
  @Input() editMode: boolean;
  @Input() kind: string;
  @Input() stepStatus: number;
  @Input() hasI4KAccount: boolean;
  @Input() hasCIAccount: boolean;
  @Output() changeTab = new EventEmitter<ProfileTab>();
  @Output() showPromotions = new EventEmitter<boolean>();

  updateOpenedTab(tabName: ProfileTab): void {
    this.changeTab.emit(tabName);
  }

  updateShowPromotions(): void {
    this.showPromotions.emit(true);
  }
}
